import React from "react";

const Services: React.FC = () => <h1>Services Page</h1>;

export default Services;
